import { render, staticRenderFns } from "./modalUploadVideo.vue?vue&type=template&id=1de7d85b&scoped=true&"
import script from "./modalUploadVideo.vue?vue&type=script&lang=js&"
export * from "./modalUploadVideo.vue?vue&type=script&lang=js&"
import style0 from "./modalUploadVideo.vue?vue&type=style&index=0&id=1de7d85b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de7d85b",
  null
  
)

export default component.exports